module.exports = __webpack_public_path__ + "img/baoxiaomi-opk-face.4d3f960a.png";